/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Zwei_Mal_Pro_Monat20Inputs */

const en__field_enum_icsrm_zwei_mal_pro_monat20 = /** @type {(inputs: _Field_Enum_Icsrm_Zwei_Mal_Pro_Monat20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`twice a month`)
};

const de__field_enum_icsrm_zwei_mal_pro_monat20 = /** @type {(inputs: _Field_Enum_Icsrm_Zwei_Mal_Pro_Monat20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zwei mal im Monat`)
};

/**
* | output |
* | --- |
* | "twice a month" |
*
* @param {_Field_Enum_Icsrm_Zwei_Mal_Pro_Monat20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_zwei_mal_pro_monat20 = /** @type {((inputs?: _Field_Enum_Icsrm_Zwei_Mal_Pro_Monat20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Zwei_Mal_Pro_Monat20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_zwei_mal_pro_monat20(inputs)
	return de__field_enum_icsrm_zwei_mal_pro_monat20(inputs)
});
export { _field_enum_icsrm_zwei_mal_pro_monat20 as "_field_enum_ICSRM_ZWEI_MAL_PRO_MONAT" }